import React from 'react';
import { render } from 'react-dom';
import Docs from './docs/';

render(<Docs />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js